<div>

  <br/>

  <!-- Categories -->
  <div class="section-categories">
    <div class="container g-0">
      <div class="row g-0">

        <!-- Coworking -->
        <div class="col-6 col-sm-auto">
          <a routerLink="{{ coworkingPath }}">
            <span class="category" [class]="{'selected' : isCoworkingSelected}">
              <i class="category-icon bi bi-lightning-fill hide-sm"></i>
              <span class="category-title">COWORKING SEATS</span>
            </span>
          </a>
        </div>

        <!-- Conference room -->
        <div class="col-6 col-sm-auto">
          <a routerLink="{{ conferenceRoomPath }}">
            <span class="category" [class]="{'selected' : isConferenceRoomSelected}">
              <i class="category-icon bi bi-lightbulb-fill hide-sm"></i>
              <span class="category-title">CONFERENCE ROOMS</span>
            </span>
          </a>
        </div>

      </div>
    </div>
  </div>

  <br/>

  <!-- Filters -->
  <div class="section-filters">
    <div id="place-list-filter" class="accordion-collapse collapse">
      <form>
        <div class="container g-0">
          <div class="row">
            <div class="col-12">
              <div class="mb-3"><strong><small>Reserve seat</small></strong></div>
            </div>
            <div class="col-6 col-sm-4">
              <div class="input-group">
                <div class="form-floating">
                  <select id="reserveDate" name="reserveDate" class="form-select" [(ngModel)]="reserveDate" (change)="changeReserveFilters()">
                    <option *ngFor="let option of reserveDateOptions" [value]="option.value">{{ option.label }}</option>
                  </select>
                  <label for="reserveDate">Date</label>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-6 col-sm-4">
              <div class="input-group">
                <div class="form-floating">
                  <select id="reserveTime" name="reserveTime" class="form-select" [(ngModel)]="reserveTime" (change)="changeReserveFilters()">
                    <option *ngFor="let option of reserveTimeOptions" [value]="option.value">{{ option.label }}</option>
                  </select>
                  <label for="reserveTime">Time</label>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-12 col-sm-4">
              <div class="input-group">
                <div class="form-floating">
                  <select id="reservePeople" name="reservePeople" class="form-select" [(ngModel)]="reservePeople" (change)="changeReserveFilters()">
                    <option *ngFor="let option of reservePeopleOptions" [value]="option.value">{{ option.label }}</option>
                  </select>
                  <label for="reservePeople">People</label>
                </div>
              </div>
              <br/>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-3 col-xxl-2">
              <div class="mb-3"><strong><small>Operation hours</small></strong></div>

              <div class="row">
                <div class="col-4 col-md-12">
                  <button class="btn btn-block btn-sm mb-2 ps-0 pe-0" (click)="changeAmenities('late-nights')" [ngClass]="{'btn-neon-blue': amenities.indexOf('late-nights') !== -1, 'btn-white': amenities.indexOf('late-nights') === -1}">Late nights</button>
                </div>
                <div class="col-4 col-md-12">
                  <button class="btn btn-block btn-sm mb-2 ps-0 pe-0" (click)="changeAmenities('weekends')" [ngClass]="{'btn-neon-blue': amenities.indexOf('weekends') !== -1, 'btn-white': amenities.indexOf('weekends') === -1}">Weekends</button>
                </div>
                <div class="col-4 col-md-12">
                  <button class="btn btn-block btn-sm mb-2 ps-0 pe-0" (click)="changeAmenities('twenty-four-seven')" [ngClass]="{'btn-neon-blue': amenities.indexOf('twenty-four-seven') !== -1, 'btn-white': amenities.indexOf('twenty-four-seven') === -1}">Open 24/7</button>
                </div>
              </div>
              <br/>
            </div>
            <div class="col-12 col-md-9 col-xxl-10">
              <div class="mb-3"><strong><small>Additional Amenities</small></strong></div>
              <div class="row">
                <div class="col-6 col-sm-4 col-xxl-3" *ngFor="let amenity of amenitiesOptions">
                  <button class="btn btn-block btn-sm mb-2 ps-0 pe-0" (click)="changeAmenities(amenity.value)" [ngClass]="{'btn-neon-blue': amenities.indexOf(amenity.value) !== -1, 'btn-white': amenities.indexOf(amenity.value) === -1}">{{ amenity.label }}</button>
                </div>
              </div>
              <br/>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>
